import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import {V1ProjectPlanPhaseAttachmentIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import MemoryContext from "../../../../util/MemoryContext";


class ProjectPlanPhaseAttachmentEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocRequest = this.getIDOCRequest() ?? "v1.ProjectPlanPhaseAttachment-001";
        let idocResponse = this.getIDOCResponse() ?? "v1.ProjectPlanPhaseAttachment-001";

        let fk = {};
        fk["ProjectPlanPhaseUSID"] = foreignKey;

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/project_plan_phase_attachments",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...(foreignKey ? fk : {}),
                ...this.getSearchSpecification()
            },
            headers: {
                "idoc-request": idocRequest,
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ProjectPlanPhaseAttachmentIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let attachment = {};

        attachment["Name"] = this.getAttributeValue("Name");
        attachment["Type"] = this.getAttributeValue("Type");
        attachment["FileSize"] = this.getAttributeValue("FileSize");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.ProjectPlanPhase-002";
        payload.ShifamedMessage.ProjectPlanPhase = {
            "USID": MemoryContext.components["ProjectPlanDetail-EO-PhaseUSID"],
            "ProjectPlanPhaseAttachment": attachment
        };

        return payload;
    };

    performInsert = () => {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/project_plan_phases",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhase-002",
                "idoc-response": "v1.ProjectPlanPhase-002",
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1ProjectPlanPhaseAttachmentIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.ProjectPlanPhaseAttachment-001";
        payload.ShifamedMessage.ProjectPlanPhaseAttachment = {
            "USID": this.getAttributeValue("USID")
        };

        let options = {
            method: "DELETE",
            url: "t3/v1/project_plan_phase_attachments",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhaseAttachment-001",
                "idoc-response": "v1.ProjectPlanPhaseAttachment-001",
            },
        };
        this.notifyDeleteStartListeners();
        EnlilAxiosRestAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default ProjectPlanPhaseAttachmentEnterpriseComponent;